import type { AddressData } from '../../types'
import type { Customer } from '@haus-storefront-react/shared-types'

const ADDRESS_DISPLAY_ORDER: (keyof AddressData)[] = [
  'fullName',
  'company',
  'addressLine1',
  'addressLine2',
  'postalCode',
  'city',
  'province',
  'countryCode',
  'phoneNumber',
]

/**
 * Format an address for read-only display (one field per line).
 * When getCountryName is provided, countryCode is resolved to the country name.
 */
export const formatAddressForDisplay = (
  addr: AddressData,
  getCountryName?: (code: string) => string,
): string =>
  ADDRESS_DISPLAY_ORDER.map((key) => {
    if (key === 'countryCode' && getCountryName) {
      return addr.countryCode ? getCountryName(addr.countryCode) : ''
    }
    return addr[key]
  })
    .filter(Boolean)
    .join('\n')

type ContactDisplayData = {
  fullName: string
  emailAddress: string
  phoneNumber: string
}

const CONTACT_DISPLAY_ORDER: (keyof ContactDisplayData)[] = [
  'fullName',
  'emailAddress',
  'phoneNumber',
]

/**
 * Format contact info for read-only display (one field per line).
 * Combines firstName and lastName into fullName.
 */
export const formatContactForDisplay = (contact: Customer): string => {
  const data: ContactDisplayData = {
    fullName: [contact.firstName, contact.lastName].filter(Boolean).join(' '),
    emailAddress: contact.emailAddress,
    phoneNumber: contact.phoneNumber ?? '',
  }
  return CONTACT_DISPLAY_ORDER.map((key) => data[key])
    .filter(Boolean)
    .join('\n')
}
